import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.25 6.8a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m1.5 0a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0M19.75 17.999a3.25 3.25 0 0 0-3.25-3.25h-9a3.25 3.25 0 0 0-3.25 3.25v2c0 .138.112.25.25.25h15a.25.25 0 0 0 .25-.25zm1.5 2a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-2a4.75 4.75 0 0 1 4.75-4.75h9a4.75 4.75 0 0 1 4.75 4.75z"
  }));
}
var IcMy = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMy));

export { IcMy as I };
